import MD99 from './Portfolio/Design/img/md99-cover.png';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

/*---------------------Technology Icons------------------------------------------------------------------------------------*/

import FigmaIcon from './img/icons/figma.png';
import IllustratorIcon from './img/icons/illustrator.png';
import ReactIcon from './img/icons/react.png';
import BootstrapIcon from './img/icons/bootstrap.png';
import CSSIcon from './img/icons/css.png';
import HTMLIcon from './img/icons/html.png';
import JavaScriptIcon from './img/icons/javascript.png';
import VSCodeIcon from './img/icons/vscode.png';
import IndesignIcon from './img/icons/indesign.png';
import GoogleIcon from './img/icons/google.png';
import PhotoshopIcon from './img/icons/photoshop.png';
import XDIcon from './img/icons/xd.png';

/*---------------------Portfolio Cover Images------------------------------------------------------------------------------------*/

import IdealExperience from './Portfolio/Design/img/ideal-experience-cover.png';
import Clover from './Portfolio/Design/img/clover-cover.png';
import PortfolioUpgrade from './Portfolio/Design/upgrade-media/unnamed (2).png';
import AgCon from './Portfolio/Design/img/ag-con-cover.png';
import SilentBattle from './Portfolio/Design/img/silent-battle-cover-3.png';
import RowansCreek from './Portfolio/Design/img/rowans-creek-cover.png';
import Railbird from './Portfolio/Design/img/railbird-cover.png';
import ThreeWillows from './Portfolio/Design/img/three-willows-cover.png';
import TotalPtConnect from './Portfolio/Design/img/totalpt-cover.png';
import Amperes from './Portfolio/Design/img/amperes&.jpg';
import BG from './Portfolio/Design/img/bg.jpg';
import Dreams from './Portfolio/Design/img/dreams.jpg';
import EastCoast from './Portfolio/Design/img/eastcoast.jpg';
import Phantom from './Portfolio/Design/img/phantom.jpg';
import SKG from './Portfolio/Design/img/skg.jpg';
import StoicismTwo from './Portfolio/Design/img/stoicism2.jpg';
import StoicismThree from './Portfolio/Design/img/stoicism3.jpg';

/*---------------------React Imports------------------------------------------------------------------------------------*/

import {
  BrowserRouter as Router,
  Link
} from "react-router-dom";
import { useRef } from 'react';
import 'lightbox.js-react/dist/index.css'
import { SlideshowLightbox, initLightboxJS } from 'lightbox.js-react'
import React, { useEffect } from 'react';

function GraphicDesignBody() {

  useEffect(() => {
    initLightboxJS("8FD0-B03E-0811-EA4A", "Individual");
  });

  const topRef = useRef(null);

  const handleClick = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }

  return (

    <div id="portfolio-section" className="bg-main-dark">
     
        <div className="content-2 text-center" style={{ marginBottom: '40px' }}>
            <b className="secondary-headline text-center">Portfolio</b>
        </div>
    

      <div className="container-fluid d-flex flex-wrap align-items-center justify-content-center text-light">
        <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 mx-3 justify-content-center g-3">

{/*------------------------------Clover------------------------------------------------------------------------------------------*/}

          <div 
            className="col text-light card-port"
            role="article"
            aria-label="Clover project"
          >
            <div style={{ position: 'relative' }}>
              <img className="card-img-top" loading="lazy" src={Clover} alt="Clover project preview" />
              <div className="overlay">
                <div className="overlay-top">
                  <p className="project-type">Web App</p>
                </div>
                <div className="overlay-center">
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
                    <p className="overlay-text">Clover</p>
                    <Link 
                      to="/clover"
                      className="btn-portfolio"
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          window.location.href = '/clover';
                        }
                      }}
                    >
                      OPEN
                    </Link>
                  </div>
                </div>
                <div className="overlay-bottom">
                  <div className="tools-section">
                    <p className="tools-label">Tools</p>
                    <div className="tools-icons">
                      <img src={FigmaIcon} alt="Figma" className="tech-icon" />
                      <img src={IllustratorIcon} alt="Illustrator" className="tech-icon" />
                      <img src={PhotoshopIcon} alt="Photoshop" className="tech-icon" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

{/*------------------------------Ideal Experience------------------------------------------------------------------------------------------*/}

          <div className="col text-light card-port">
            <div style={{ position: 'relative' }}>
              <img className="card-img-top" loading="lazy" src={IdealExperience} alt="Ideal Experience" />
              <div className="overlay">
                <div className="overlay-top">
                  <p className="project-type">Editorial Design</p>
                </div>
                <div className="overlay-center">
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
                    <p className="overlay-text">The Ideal GenAI Experience</p>
                    <Link to="/ideal-experience">
                      <button className="btn-portfolio">OPEN</button>
                    </Link>
                  </div>
                </div>
                <div className="overlay-bottom">
                  <div className="tools-section">
                    <p className="tools-label">Tools</p>
                    <div className="tools-icons">
                      <img src={IndesignIcon} alt="Indesign" className="tech-icon" />
                      <img src={IllustratorIcon} alt="Illustrator" className="tech-icon" />
                      <img src={FigmaIcon} alt="Figma" className="tech-icon" />
                      <img src={GoogleIcon} alt="Google" className="tech-icon" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

{/*------------------------------Portfolio Upgrade------------------------------------------------------------------------------------------*/}

          <div 
            className="col text-light card-port"
            role="article"
            aria-label="Portfolio Upgrade project"
          >
            <div style={{ position: 'relative' }}>
              <img 
                className="card-img-top" 
                loading="lazy" 
                src={PortfolioUpgrade} 
                alt="Portfolio Upgrade project preview"
                style={{
                  width: '100%',
                  height: 'auto',
                  aspectRatio: '1/1',
                  objectFit: 'cover',
                  objectPosition: 'center'
                }}
              />
              <div className="overlay">
                <div className="overlay-top">
                  <p className="project-type">Case Study</p>
                </div>
                <div className="overlay-center">
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
                    <p className="overlay-text">Portfolio Upgrade</p>
                    <Link 
                      to="/portfolio-upgrade"
                      className="btn-portfolio"
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          window.location.href = '/portfolio-upgrade';
                        }
                      }}
                    >
                      OPEN
                    </Link>
                  </div>
                </div>
                <div className="overlay-bottom">
                  <div className="tools-section">
                    <p className="tools-label">Tools</p>
                    <div className="tools-icons">
                      <img src={ReactIcon} alt="React" className="tech-icon" />
                      <img src={JavaScriptIcon} alt="JavaScript" className="tech-icon" />
                      <img src={VSCodeIcon} alt="VS Code" className="tech-icon" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

{/*------------------------------MD99------------------------------------------------------------------------------------------*/}

          <div className="col text-light card-port">
            <div style={{ position: 'relative' }}>
              <img className="card-img-top" loading="lazy" src={MD99} alt="MD99" />
              <div className="overlay">
                <div className="overlay-top">
                  <p className="project-type">Web App</p>
                </div>
                <div className="overlay-center">
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
                    <p className="overlay-text">MyDesign99</p>
                    <Link to="/md99">
                      <button className="btn-portfolio">OPEN</button>
                    </Link>
                  </div>
                </div>
                <div className="overlay-bottom">
                  <div className="tools-section">
                    <p className="tools-label">Tools</p>
                    <div className="tools-icons">
                      <img src={ReactIcon} alt="React" className="tech-icon" />
                      <img src={BootstrapIcon} alt="Bootstrap" className="tech-icon" />
                      <img src={CSSIcon} alt="CSS" className="tech-icon" />
                      <img src={HTMLIcon} alt="HTML" className="tech-icon" />
                      <img src={JavaScriptIcon} alt="JavaScript" className="tech-icon" />
                      <img src={VSCodeIcon} alt="VSCode" className="tech-icon" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

{/*------------------------------AG CON------------------------------------------------------------------------------------------*/}

          <div className="col text-light card-port">
            <div style={{ position: 'relative' }}>
              <img className="card-img-top" loading="lazy" src={AgCon} alt="AG CON" />
              <div className="overlay">
                <div className="overlay-top">
                  <p className="project-type">Brand Identity</p>
                </div>
                <div className="overlay-center">
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
                    <p className="overlay-text">AG CON 2026</p>
                    <Link to="/ag-con">
                      <button className="btn-portfolio">OPEN</button>
                    </Link>
                  </div>
                </div>
                <div className="overlay-bottom">
                  <div className="tools-section">
                    <p className="tools-label">Tools</p>
                    <div className="tools-icons">
                      <img src={IllustratorIcon} alt="Illustrator" className="tech-icon" />
                      <img src={PhotoshopIcon} alt="Photoshop" className="tech-icon" />
                      <img src={IndesignIcon} alt="InDesign" className="tech-icon" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

{/*------------------------------Silent Battle------------------------------------------------------------------------------------------*/}

          <div className="col text-light card-port">
            <div style={{ position: 'relative' }}>
              <img className="card-img-top" loading="lazy" src={SilentBattle} alt="Silent Battle" />
              <div className="overlay">
                <div className="overlay-top">
                  <p className="project-type">Editorial Design</p>
                </div>
                <div className="overlay-center">
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
                    <p className="overlay-text">Silent Battle</p>
                    <Link to="/silent-battle">
                      <button className="btn-portfolio">OPEN</button>
                    </Link>
                  </div>
                </div>
                <div className="overlay-bottom">
                  <div className="tools-section">
                    <p className="tools-label">Tools</p>
                    <div className="tools-icons">
                      <img src={IllustratorIcon} alt="Illustrator" className="tech-icon" />
                      <img src={PhotoshopIcon} alt="Photoshop" className="tech-icon" />
                      <img src={IndesignIcon} alt="InDesign" className="tech-icon" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

{/*------------------------------Rowan's Creek------------------------------------------------------------------------------------------*/}

          {/* <div className="col text-light card-port">
            <div style={{ position: 'relative' }}>
              <img className="card-img-top" loading="lazy" src={RowansCreek} alt="Rowans Creek" />
              <div className="overlay">
                <div className="overlay-top">
                  <p className="project-type">Brand Identity</p>
                </div>
                <div className="overlay-center">
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
                    <p className="overlay-text">Rowan's Creek</p>
                    <Link to="/rowans-creek">
                      <button className="btn-portfolio">OPEN</button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

{/*------------------------------Railbird------------------------------------------------------------------------------------------*/}

          {/* <div className="col text-light card-port">
            <div style={{ position: 'relative' }}>
              <img className="card-img-top" loading="lazy" src={Railbird} alt="Railbird" />
              <div className="overlay">
                <div className="overlay-top">
                  <p className="project-type">Brand Identity</p>
                </div>
                <div className="overlay-center">
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
                    <p className="overlay-text">Railbird</p>
                    <Link to="/railbird">
                      <button className="btn-portfolio">OPEN</button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

{/*------------------------------Three Willows------------------------------------------------------------------------------------------*/}

          {/* <div className="col text-light card-port">
            <div style={{ position: 'relative' }}>
              <img className="card-img-top" loading="lazy" src={ThreeWillows} alt="Three Willows" />
              <div className="overlay">
                <div className="overlay-top">
                  <p className="project-type">Brand Identity</p>
                </div>
                <div className="overlay-center">
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
                    <p className="overlay-text">Three Willows</p>
                    <Link to="/three-willows">
                      <button className="btn-portfolio">OPEN</button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

{/*------------------------------Total PT Connect------------------------------------------------------------------------------------------*/}

          <div className="col text-light card-port">
            <div style={{ position: 'relative' }}>
              <img className="card-img-top" loading="lazy" src={TotalPtConnect} alt="Total PT Connect" />
              <div className="overlay">
                <div className="overlay-top">
                  <p className="project-type">Web App</p>
                </div>
                <div className="overlay-center">
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
                    <p className="overlay-text">Total PT Connect</p>
                    <Link to="/total-pt-connect">
                      <button className="btn-portfolio">OPEN</button>
                    </Link>
                  </div>
                </div>
                <div className="overlay-bottom">
                  <div className="tools-section">
                    <p className="tools-label">Tools</p>
                    <div className="tools-icons">
                      <img src={XDIcon} alt="XD" className="tech-icon" />
                      <img src={PhotoshopIcon} alt="Photoshop" className="tech-icon" />
                      <img src={VSCodeIcon} alt="VSCode" className="tech-icon" />
                      <img src={HTMLIcon} alt="HTML" className="tech-icon" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

{/*------------------------------Ampere's &------------------------------------------------------------------------------------------*/}

          {/* <div className="col text-light card-port">
            <div style={{ position: 'relative' }}>
              <img className="card-img-top" loading="lazy" src={Amperes} alt="Ampere's &" />
              <div className="overlay">
                <div className="overlay-top">
                  <p className="project-type">Editorial Design</p>
                </div>
                <div className="overlay-center">
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
                    <p className="overlay-text">Ampere's &</p>
                    <Link to="/amperes">
                      <button className="btn-portfolio">OPEN</button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

{/*------------------------------BG------------------------------------------------------------------------------------------*/}

          {/* <div className="col text-light card-port">
            <div style={{ position: 'relative' }}>
              <img className="card-img-top" loading="lazy" src={BG} alt="BG" />
              <div className="overlay">
                <div className="overlay-top">
                  <p className="project-type">Logo Design</p>
                </div>
                <div className="overlay-center">
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
                    <p className="overlay-text">BG</p>
                    <Link to="/bg">
                      <button className="btn-portfolio">OPEN</button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

{/*------------------------------Dreams------------------------------------------------------------------------------------------*/}

          <div className="col text-light card-port">
            <div style={{ position: 'relative' }}>
              <img className="card-img-top" loading="lazy" src={Dreams} alt="Dreams" />
              <div className="overlay">
                <div className="overlay-top">
                  <p className="project-type">Poster Design</p>
                </div>
                <div className="overlay-center">
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
                    <p className="overlay-text">Dream-Goal Posters</p>
                    <Link to="/dream-posters">
                      <button className="btn-portfolio">OPEN</button>
                    </Link>
                  </div>
                </div>
                <div className="overlay-bottom">
                  <div className="tools-section">
                    <p className="tools-label">Tools</p>
                    <div className="tools-icons">
                      <img src={IllustratorIcon} alt="Illustrator" className="tech-icon" />
                      <img src={PhotoshopIcon} alt="Photoshop" className="tech-icon" />
                      <img src={IndesignIcon} alt="InDesign" className="tech-icon" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

{/*------------------------------EastCoast------------------------------------------------------------------------------------------*/}

          {/* <div className="col text-light card-port">
            <div style={{ position: 'relative' }}>
              <img className="card-img-top" loading="lazy" src={EastCoast} alt="EastCoast" />
              <div className="overlay">
                <div className="overlay-top">
                  <p className="project-type">Typography</p>
                </div>
                <div className="overlay-center">
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
                    <p className="overlay-text">East Coast</p>
                    <Link to="/eastcoast">
                      <button className="btn-portfolio">OPEN</button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

{/*------------------------------Phantom------------------------------------------------------------------------------------------*/}

          <div className="col text-light card-port">
            <div style={{ position: 'relative' }}>
              <img className="card-img-top" loading="lazy" src={Phantom} alt="Phantom" />
              <div className="overlay">
                <div className="overlay-top">
                  <p className="project-type">Print Marketing</p>
                </div>
                <div className="overlay-center">
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
                    <p className="overlay-text">Phantom Fireworks</p>
                    <Link to="/phantom">
                      <button className="btn-portfolio">OPEN</button>
                    </Link>
                  </div>
                </div>
                <div className="overlay-bottom">
                  <div className="tools-section">
                    <p className="tools-label">Tools</p>
                    <div className="tools-icons">
                      <img src={IllustratorIcon} alt="Illustrator" className="tech-icon" />
                      <img src={PhotoshopIcon} alt="Photoshop" className="tech-icon" />
                      <img src={IndesignIcon} alt="InDesign" className="tech-icon" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

{/*------------------------------Sea Kayak Georgia------------------------------------------------------------------------------------------*/}

          <div className="col text-light card-port">
            <div style={{ position: 'relative' }}>
              <img className="card-img-top" loading="lazy" src={SKG} alt="Sea Kayak Georgia" />
              <div className="overlay">
                <div className="overlay-top">
                  <p className="project-type">Poster Design</p>
                </div>
                <div className="overlay-center">
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
                    <p className="overlay-text">Sea Kayak Georgia</p>
                    <Link to="/skg">
                      <button className="btn-portfolio">OPEN</button>
                    </Link>
                  </div>
                </div>
                <div className="overlay-bottom">
                  <div className="tools-section">
                    <p className="tools-label">Tools</p>
                    <div className="tools-icons">
                      <img src={IllustratorIcon} alt="Illustrator" className="tech-icon" />
                      <img src={PhotoshopIcon} alt="Photoshop" className="tech-icon" />
                      <img src={IndesignIcon} alt="InDesign" className="tech-icon" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

{/*------------------------------Stoked on Stoicism Two------------------------------------------------------------------------------------------*/}

          <div className="col text-light card-port">
            <div style={{ position: 'relative' }}>
              <img className="card-img-top" loading="lazy" src={StoicismTwo} alt="Stoked on Stoicism Two" />
              <div className="overlay">
                <div className="overlay-top">
                  <p className="project-type">Editorial Design</p>
                </div>
                <div className="overlay-center">
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
                    <p className="overlay-text">Stoked Two</p>
                    <Link to="/stoked-two">
                      <button className="btn-portfolio">OPEN</button>
                    </Link>
                  </div>
                </div>
                <div className="overlay-bottom">
                  <div className="tools-section">
                    <p className="tools-label">Tools</p>
                    <div className="tools-icons">
                      <img src={IllustratorIcon} alt="Illustrator" className="tech-icon" />
                      <img src={PhotoshopIcon} alt="Photoshop" className="tech-icon" />
                      <img src={IndesignIcon} alt="InDesign" className="tech-icon" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

{/*------------------------------Stoked on Stoicism Three------------------------------------------------------------------------------------------*/}

          <div className="col text-light card-port">
            <div style={{ position: 'relative' }}>
              <img className="card-img-top" loading="lazy" src={StoicismThree} alt="Stoked on Stoicism Three" />
              <div className="overlay">
                <div className="overlay-top">
                  <p className="project-type">Editorial Design</p>
                </div>
                <div className="overlay-center">
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
                    <p className="overlay-text">Stoked Three</p>
                    <Link to="/stoked-three">
                      <button className="btn-portfolio">OPEN</button>
                    </Link>
                  </div>
                </div>
                <div className="overlay-bottom">
                  <div className="tools-section">
                    <p className="tools-label">Tools</p>
                    <div className="tools-icons">
                      <img src={IllustratorIcon} alt="Illustrator" className="tech-icon" />
                      <img src={PhotoshopIcon} alt="Photoshop" className="tech-icon" />
                      <img src={IndesignIcon} alt="InDesign" className="tech-icon" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      
      <div className="container-fluid text-center mt-5 pb-5">
        <button onClick={handleClick} className="btn btn-return">Return to Top</button>
      </div>
      
    </div>
  );
}

export default GraphicDesignBody;
